// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "./registerServiceWorker";

import "./assets/styles/fonts.css";
import "animate.css/animate.css";
import "./assets/styles/variables.scss";
import "aos/dist/aos.css";
import posthogPlugin from './plugins/posthog';

import AOS from "aos";
import VueCountdownTimer from "vuejs-countdown-timer";
import store from "./store";

import pkg from "../package.json";

Vue.config.productionTip = false;
Vue.use(VueCountdownTimer);
Vue.use(posthogPlugin);

new Vue({
  store,
  created() {
    AOS.init();
  },
  router,
  data: {
    version: pkg.version
  },
  render: h => h(App)
}).$mount("#app");
